var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingUpload
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingUpload = $event
      }
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingDownload
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingDownload = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1 col-md-12",
    staticStyle: {
      "margin-bottom": "0rem",
      "padding": "0px",
      "background-color": "white"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button', {
        active: _vm.currentTab === tab.key
      }],
      style: (("" + ((_vm.tabs.length==1) ? 'width: 100%;' : ''))),
      attrs: {
        "id": tab.value
      },
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key;
          _vm.secondFunction(tab);
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.value) + "\n          ")])
  }), 0), _vm._v(" "), _c('fieldset', [(_vm.currentTab == 'upload') ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onUploadSubmit.apply(null, arguments)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("FM/LM Mapping File")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('configFile')
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload File",
      "name": "configFile",
      "id": "configFile",
      "accept": ".csv,.zip"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only .csv or .zip files allowed. Max size 5 MB.")])], 1), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('configFile')),
      expression: "errors.has('configFile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Upload file is required.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "javascript:void(0)",
      "title": 'Download FM/LM Mapping sample .csv'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadSampleCsv.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" FM/LM Mapping Sample\n                   ")])], 1), _vm._v(" "), (_vm.failed.length > 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Download Failed Rows")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download failed FM/LM Mapping rows"
    },
    on: {
      "click": _vm.exportFailedConfig
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("Download\n                          "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "red"
    }
  })])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "expected-column"
  }, [_c('div', {
    staticClass: "expected-title"
  }, [_vm._v("Expected columns:")]), _vm._v(" "), _c('div', {
    staticClass: "column-tags"
  }, _vm._l((_vm.mappingColumns), function(col) {
    return _c('span', {
      key: col.key,
      class: ['column-tag', col.required ? 'mandatory' : 'optional'],
      attrs: {
        "title": col.required ? 'Required column' : 'Optional column'
      }
    }, [_vm._v("\n                          " + _vm._s(col.header) + "\n                        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "layout-note"
  }, [_vm._v("\n                        Column headers in the uploaded file are normalized (casing and extra spaces).\n                        All five columns are required on every row. LM Hub Id and FM Parent Hub Id must be\n                        positive whole numbers and cannot be the same on a single row.\n                        Is Active must be true or false (case insensitive).\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "layout-note"
  }, [_c('strong', [_vm._v("Note:")]), _vm._v(" Upsert key is LM Hub Id plus FM Parent Hub Id — the same LM\n                        may map to multiple FM parents in one file. Rows not in the upload file are not\n                        deactivated automatically.\n                      ")])])])]), _vm._v(" "), (_vm.lastUploadSummary) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "upload-summary"
  }, [_c('div', {
    staticClass: "upload-summary-title"
  }, [_vm._v("Last upload summary")]), _vm._v(" "), _c('div', {
    staticClass: "upload-summary-body"
  }, [(_vm.lastUploadSummary.totalRows != null) ? _c('span', {
    staticClass: "upload-summary-chip total"
  }, [_vm._v("\n                          Total rows: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.totalRows))])]) : _vm._e(), _vm._v(" "), (_vm.lastUploadSummary.validCount != null) ? _c('span', {
    staticClass: "upload-summary-chip valid"
  }, [_vm._v("\n                          Valid: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.validCount))])]) : _vm._e(), _vm._v(" "), (_vm.lastUploadSummary.insertedCount != null) ? _c('span', {
    staticClass: "upload-summary-chip inserted"
  }, [_vm._v("\n                          New inserted: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.insertedCount))])]) : _vm._e(), _vm._v(" "), (_vm.lastUploadSummary.updatedCount != null) ? _c('span', {
    staticClass: "upload-summary-chip updated"
  }, [_vm._v("\n                          Existing updated: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.updatedCount))])]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "submit",
      "title": "Upload FM/LM Mapping file"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "margin-top": "15px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSearching
    },
    on: {
      "update:active": function($event) {
        _vm.isSearching = $event
      }
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "text-primary"
  }, [_vm._v("FM/LM Mappings")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Download FM/LM Mappings")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download current FM/LM mappings from database"
    },
    on: {
      "click": _vm.downloadMappingsFromDB
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("\n                      Download CSV\n                      "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "#20a8d8"
    }
  })])])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n                  Exports active mapping rows only (LM Hub, LM Hub Id, FM Parent Hub, FM Parent Hub Id, Is Active).\n                ")])], 1), _vm._v(" "), _c('div', {
    style: (_vm.mappings.length > 8 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("LM Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("LM Hub Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("FM Parent Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("FM Parent Hub Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Is Active")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.mappings), function(row, index) {
    return _c('tr', {
      key: row.id || index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((_vm.pageno * _vm.limit) + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.lmHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.lmHubId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.fmParentHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.fmParentHubId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      style: ({
        color: row.isActive ? 'green' : 'red'
      })
    }, [_vm._v("\n                        " + _vm._s(row.isActive ? 'Active' : 'Inactive') + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "title": "Toggle active status"
      },
      on: {
        "click": function($event) {
          return _vm.openEditRow(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])])
  }), _vm._v(" "), (_vm.mappings.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > _vm.limit),
      expression: "totalRows > limit"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)]) : (_vm.currentTab == 'history') ? _c('b-card', [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingHistory
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingHistory = $event
      }
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "text-primary"
  }, [_vm._v("Audit History")]), _vm._v(" "), _c('div', {
    style: (_vm.historyRows.length > 8 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Modified By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Modified Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Remarks")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.historyRows), function(row, index) {
    return _c('tr', {
      key: row.id || index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((_vm.historyPageno * _vm.historyLimit) + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      class: _vm.auditActionBadgeClass(row.action)
    }, [_vm._v(_vm._s(row.action))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.modifiedBy))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(row.modifiedDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(row.remarks))])])
  }), _vm._v(" "), (_vm.historyRows.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historyTotalRows > _vm.historyLimit),
      expression: "historyTotalRows > historyLimit"
    }],
    attrs: {
      "page-count": _vm.historyPageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getHistoryPagination,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)]) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "editFmLmMappingModal",
      "title": "Edit FM/LM Mapping",
      "hide-footer": "",
      "hide-header": ""
    },
    model: {
      value: (_vm.isEditModalShow),
      callback: function($$v) {
        _vm.isEditModalShow = $$v
      },
      expression: "isEditModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Edit FM/LM Mapping")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeEditModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSavingEdit
    },
    on: {
      "update:active": function($event) {
        _vm.isSavingEdit = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("LM Hub")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.lmHubName
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("LM Hub Id")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.lmHubId
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("FM Parent Hub")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.fmParentHubName
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("FM Parent Hub Id")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.fmParentHubId
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Is Active")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('label', {
    staticClass: "switch",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForm.isActive),
      expression: "editForm.isActive"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editForm.isActive) ? _vm._i(_vm.editForm.isActive, null) > -1 : (_vm.editForm.isActive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.editForm.isActive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.editForm, "isActive", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.editForm, "isActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.editForm, "isActive", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v(_vm._s(_vm.editForm.isActive ? 'Active' : 'Inactive'))])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isSavingEdit
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeEditModal
    }
  }, [_vm._v("\n            Cancel\n          ")])])])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-bottom": "0.5%",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticStyle: {
      "border": "0px"
    }
  }, [_vm._v("FM/LM Mapping Master")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28744170","hasScoped":true}!./src/views/components/LmParentMapping/LmParentMapping.html
// module id = 2083
// module chunks = 2